import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import * as DOMPurify from "dompurify";
import { DataMigrationError, DataMigrationErrorTypes } from "../../../../../../models/data-migration/data-migration-errors.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { StringUtilities } from "../../../../../../utilities/strings";

@autoinject
export class ImportExcelErrorsDialog {

	public errors: DataMigrationError[];

	constructor(private dialogClientService: DialogClientService, private i18N: I18N) { }

	activate(params: any) {
		this.errors = JSON.parse(params.errorsJson);
	}

	close() {
		this.dialogClientService.hide();
	}

	getErrorMessage(error: DataMigrationError): string {
		if (error.errorMessage && error.errorMessage.trim()) {
			let translated = this.i18N.tr(error.errorMessage);

			if (error.errorMessageParams && error.errorMessageParams.length > 0)
				translated = StringUtilities.formatString(translated, error.errorMessageParams);

			return DOMPurify.sanitize(translated);
		}

		switch (error.errorType) {
			case DataMigrationErrorTypes.Error:
				return this.i18N.tr('excel-error-unkown-text');
			case DataMigrationErrorTypes.InvalidFormat:
				return this.i18N.tr('excel-error-format-text');
			case DataMigrationErrorTypes.InvalidFormatDate:
				return this.i18N.tr('excel-error-format-date-text');
			case DataMigrationErrorTypes.InvalidFormatEmail:
				return this.i18N.tr('excel-error-format-email-text');
			case DataMigrationErrorTypes.InvalidFormatNumber:
				return this.i18N.tr('excel-error-format-number-text');
			case DataMigrationErrorTypes.InvalidFormatPhone:
				return this.i18N.tr('excel-error-format-phone-text');
			case DataMigrationErrorTypes.MappedEntityNotFound:
				return this.i18N.tr('excel-error-mapped-entity-not-found-text');
			case DataMigrationErrorTypes.Required:
				return this.i18N.tr('excel-error-required-text');
		}
	}
}
